import 'twin.macro'

import WarningIcon from 'assets/icons/warning-icon.svg?component'
import { Fragment, ReactNode } from 'react'
import tw, { TwStyle } from 'twin.macro'

type AlertProps = {
  children: ReactNode
  icon?: ReactNode
  twStyle?: TwStyle
}

const Alert = ({ icon = <WarningIcon tw='flex-shrink-0 text-[#FBD655]' />, children, twStyle }: AlertProps) => {
  return (
    <div css={[tw`p-3 flex space-x-2 items-start bg-tertiary rounded-xl`, twStyle]}>
      <Fragment>{icon}</Fragment>
      {children}
    </div>
  )
}

export default Alert
